import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { dispatch } from 'store';
import { WhatsappEditTemplate, WhatsappOriginalTemplate, WhatsappTemplate } from 'types/templates';
import { fetcher } from 'utils/axios';

const initialState: {
  whatsappTemplates: WhatsappTemplate[];
  whatsappOriginalTemplates: WhatsappOriginalTemplate[];
  languages: string[];
  errorPopup: {
    show: boolean;
    template: WhatsappEditTemplate | null;
    /** הודעת שגיאה מתורגמת להצגה בפופאפ (בנוסף לטקסט הכללי) */
    errorMessage: string | null;
  };
} = {
  whatsappTemplates: [],
  whatsappOriginalTemplates: [],
  languages: [],
  errorPopup: {
    show: false,
    template: null,
    errorMessage: null,
  },
};

const templatesSlice = createSlice({
  name: 'templates',
  initialState,
  reducers: {
    setWhatsappTemplates(state, action: PayloadAction<WhatsappTemplate[]>) {
      state.whatsappTemplates = action.payload;
    },
    setWhatsappOriginalTemplates(state, action: PayloadAction<WhatsappOriginalTemplate[]>) {
      state.whatsappOriginalTemplates = action.payload;
    },
    storeDeleteTemplate(state, action: PayloadAction<{ id: string; name: string }>) {
      const { id, name } = action.payload;
      const index = state.whatsappTemplates.findIndex((template) => template.id === id);
      if (index !== -1) {
        state.whatsappTemplates.splice(index, 1);
      }
      const indexOriginal = state.whatsappOriginalTemplates.findIndex((template) => template.name === name);
      if (indexOriginal !== -1) {
        state.whatsappOriginalTemplates.splice(indexOriginal, 1);
      }
    },
    setAllTemplates(
      state,
      action: PayloadAction<{
        whatsappTemplates: WhatsappTemplate[];
        whatsappOriginalTemplates: WhatsappOriginalTemplate[];
        languages: string[];
      }>,
    ) {
      state.whatsappTemplates = action.payload.whatsappTemplates;
      state.whatsappOriginalTemplates = action.payload.whatsappOriginalTemplates;
      state.languages = action.payload.languages;
    },
    resetTemplates(state) {
      return initialState;
    },
    updateErrorPopup(
      state,
      action: PayloadAction<{
        show?: boolean;
        template?: WhatsappEditTemplate | null;
        errorMessage?: string | null;
      }>,
    ) {
      Object.assign(state.errorPopup, action.payload);
    },
  },
});

export default templatesSlice.reducer;
export const {
  setWhatsappTemplates,
  setWhatsappOriginalTemplates,
  setAllTemplates,
  storeDeleteTemplate,
  resetTemplates,
  updateErrorPopup,
} = templatesSlice.actions;

export async function getWhatsappTemplates() {
  try {
    const data = await fetcher('get', '/api/services/GetWhatsappTemplates', 'newapi');
    if (data) {
      dispatch(
        setAllTemplates({
          whatsappTemplates: data?.whatsappTemplates || [],
          whatsappOriginalTemplates: data?.whatsappOriginalTemplates || [],
          languages: data?.languages || [],
        }),
      );
    }
  } catch (error) {
    console.warn('getCompanyData err: ', error);
  }
}
export async function fetchDeleteWhatsappTemplate(id: string, name: string) {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/wa-business/deleteTemplate',
        {
          data: {
            name: name,
            hsm_id: id,
          },
        },
      ],
      'history',
    );

    if (data?.result) {
      // await getWhatsappTemplates();
      dispatch(storeDeleteTemplate({ id, name }));
    }

    return data || null;
  } catch (error) {
    console.warn('fetchDeleteWhatsappTemplate err: ', error);
    return null;
  }
}
export function handleErrorPopup(params: {
  show?: boolean;
  template?: WhatsappEditTemplate | null;
  errorMessage?: string | null;
}) {
  dispatch(updateErrorPopup({ ...params }));
}
